/**
 * Soovitusprogrammi ("Kutsu sõpru") API-klient - kasutaja koondvaade
 * (`GET /api/account/referral`, KASUTAJA-skoobitud, X-Site-Id pole vaja).
 * Kui programm on väljas, vastab server 404 (`referral_disabled`) →
 * AccountLayout peidab tabi täielikult. Kuju vastab backend'i
 * `modules/referral/service.ts` `getAccountReferralSummary`-le.
 */
import { api } from "./api";

export type ReferralCreditKind =
  | "referral_reward" | "referral_welcome" | "adjustment" | "release"
  // Kulutus-read (negatiivne `amountCents`), vt billing/lib/credit.ts.
  | "spend_purchase" | "spend_stripe";
export type ReferralCreditStatus =
  | "pending" | "vested" | "consumed" | "spent" | "released" | "pushed" | "voided" | "expired";

export interface ReferralCreditRow {
  id: string;
  kind: ReferralCreditKind;
  amountCents: number;
  status: ReferralCreditStatus;
  createdAt: string;
  vestedAt: string | null;
  pushedAt: string | null;
}

export interface ReferralSummary {
  enabled: boolean;
  code: string;
  link: string;
  stats: {
    invited: number;
    qualified: number;
    pending: number;
    credited: number;
    declined: number;
  };
  credits: {
    /** Küpsemata (hold-ajal ootel) preemiad. */
    pendingCents: number;
    /** Kohe kulutatav kontokrediit (rahakoti saldo). */
    vestedCents: number;
    /** Ajalooline: v1-s Stripe'i kliendisaldole kantud summa. */
    pushedCents: number;
    /** Kokku kulutatud (ostud + arvele kantud). */
    spentCents: number;
    /** Lähim aegumistähtaeg (ISO) või null. */
    nextExpiryAt: string | null;
    rows: ReferralCreditRow[];
  };
  rules: {
    rewardCents: number;
    friendRewardCents: number;
    minPlan: string;
    cycles: string[];
    holdDays: number;
    windowDays: number;
  };
}

export const referral = {
  summary: () => api.get<ReferralSummary>("/account/referral"),
};
